import { Link } from "react-router-dom";
import { useTheme } from "next-themes";
import { ArrowLeft, Sun, Moon } from "lucide-react";

export default function PolicyLayout({ children, title, subtitle }) {
  const { theme, setTheme } = useTheme();

  return (
    <div className="min-h-screen bg-background text-foreground font-body" data-testid="policy-page">
      {/* Minimal Header */}
      <header className="sticky top-0 z-50 glass-header bg-background/80 border-b border-border/50">
        <div className="max-w-7xl mx-auto px-6 sm:px-12">
          <div className="flex items-center justify-between h-16 sm:h-20">
            <Link
              to="/"
              className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors"
              data-testid="policy-back-link"
            >
              <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
              <span className="text-sm font-medium">Back to home</span>
            </Link>
            <Link to="/" className="font-heading text-2xl font-semibold tracking-tight text-foreground" data-testid="policy-logo">
              Cita Rush
            </Link>
            <button
              onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
              className="p-2 rounded-sm text-muted-foreground hover:text-foreground transition-colors"
              data-testid="policy-theme-toggle"
              aria-label="Toggle theme"
            >
              {theme === "dark" ? <Sun className="w-5 h-5" strokeWidth={1.5} /> : <Moon className="w-5 h-5" strokeWidth={1.5} />}
            </button>
          </div>
        </div>
      </header>

      {/* Hero banner */}
      <div className="bg-muted/50 py-16 sm:py-20 border-b border-border/30">
        <div className="max-w-4xl mx-auto px-6 sm:px-12">
          <p className="font-mono text-xs tracking-[0.2em] uppercase font-semibold text-[hsl(var(--accent))] mb-4">
            {subtitle || "Legal"}
          </p>
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight font-medium" data-testid="policy-title">
            {title}
          </h1>
        </div>
      </div>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 sm:px-12 py-16 sm:py-20">
        <div className="prose-policy" data-testid="policy-content">
          {children}
        </div>
      </main>

      {/* Minimal Footer */}
      <footer className="py-12 border-t border-border/50">
        <div className="max-w-4xl mx-auto px-6 sm:px-12 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} Cita Rush. All rights reserved. 18+ only.
          </p>
          <div className="flex gap-4">
            <Link to="/terms" className="text-xs text-muted-foreground hover:text-foreground transition-colors">Terms</Link>
            <Link to="/privacy" className="text-xs text-muted-foreground hover:text-foreground transition-colors">Privacy</Link>
            <Link to="/refund-policy" className="text-xs text-muted-foreground hover:text-foreground transition-colors">Refund Policy</Link>
            <Link to="/code-of-conduct" className="text-xs text-muted-foreground hover:text-foreground transition-colors">Code of Conduct</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
